import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { TextAlign } from "chart.js";
import { DOCUMENT_TEMPLATE_PLACEHOLDER_TYPES, PlacehodlerFormValues } from "./PagePlaceholdersForm";
import { previewFonts } from "consts/documents";

import { Resizable } from "re-resizable";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { HtmlPlaceholderPreview } from "./preview/HtmlPlaceholderPreview";
interface DocumentPreview {
  docWidth: string;
  docHeight: string;
  backgroundImage: string;
  className?: string;
  placeholders: PlacehodlerFormValues[];
  fillPlaceholdersBackground?: boolean;
  hide?: boolean;
}

const ptToPx = (pt: number) => Math.round(pt * 1.333); // 1pt = 1.333px
export const DocumentPreview = ({
  docWidth,
  docHeight,
  fillPlaceholdersBackground,
  className = "",
  backgroundImage,
  placeholders,
  hide,
}: DocumentPreview) => {
  const [size, _] = useState(() => {
    const widthPt = +docWidth.replace("pt", "");
    const heightPt = +docHeight.replace("pt", "");

    return { width: ptToPx(widthPt), height: ptToPx(heightPt) };
  });
  return (
    <TransformWrapper>
      <TransformComponent wrapperStyle={{ maxHeight: hide ? "" : "calc(100vh - 16rem)" }}>
        <Resizable style={style} minWidth={size.width} minHeight={size.height} className={className}>
          <div
            style={{ backgroundImage: `url('${backgroundImage}')`, width: docWidth, height: docHeight }}
            className={`relative border bg-contain bg-center bg-no-repeat ${className}`}
          >
            {placeholders.map((x) => {
              switch (+x.type) {
                case DOCUMENT_TEMPLATE_PLACEHOLDER_TYPES.TEXT:
                  return (
                    <TextPlaceholderPreview
                      key={uuidv4()}
                      x={x}
                      fillPlaceholdersBackground={fillPlaceholdersBackground}
                    />
                  );
                case DOCUMENT_TEMPLATE_PLACEHOLDER_TYPES.IMAGE:
                  return <ImagePlaceholderPreview key={uuidv4()} x={x} />;
                case DOCUMENT_TEMPLATE_PLACEHOLDER_TYPES.HTML:
                  return (
                    <HtmlPlaceholderPreview
                      key={uuidv4()}
                      x={x}
                      fillPlaceholdersBackground={fillPlaceholdersBackground}
                    />
                  );
                default:
                  return null;
              }
            })}
          </div>
        </Resizable>
      </TransformComponent>
    </TransformWrapper>
  );
};
const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "solid 3px #007886",
  background: "#80d6df",
} as const;
interface ImagePlaceholderPreviewProps {
  x: PlacehodlerFormValues;
}
const ImagePlaceholderPreview = ({ x }: ImagePlaceholderPreviewProps) => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: `${x.top}pt`,
        left: `${x.left}pt`,
        width: `${x.width}pt`,
        height: `${x.height}pt`,
        background: "linear-gradient(#4d4949, rgb(78, 194, 248))",
      }}
    ></div>
  );
};
interface TextPlaceholderPreviewProps {
  x: PlacehodlerFormValues;
  fillPlaceholdersBackground?: boolean;
}
const TextPlaceholderPreview = ({ x, fillPlaceholdersBackground }: TextPlaceholderPreviewProps) => {
  const displayText = x.uppercase ? x.example?.toUpperCase() : x.example;

  return (
    <div
      style={{
        color: x.color ?? "",
        backgroundColor: fillPlaceholdersBackground ? "rgba(131,131,131,0.2)" : undefined,
        position: "absolute",
        fontSize: x.fontSize ? `${x.fontSize}pt` : "20px",
        bottom: `${+x.top + 2}pt`, // + 2
        left: `${x.left}pt`,
        width: `${x.width}pt`,
        textAlign: textAlignmentOptions[x.textAlignment ?? 1],
        // @ts-ignore
        ...previewFonts[x.fontFamily ?? ""],
      }}
    >
      {displayText}
    </div>
  );
};

const textAlignmentOptions: Record<number, TextAlign> = {
  0: "left",
  1: "center",
  2: "right",
};
